import React from 'react';
import DataResource from '../../common/v4/DataResource'
import Panel from '../../common/portal/Panel'
import Tabs from '../../common/Tabs'

const Campaigns = (props) => {
    
    const data = {
        url: '/admin/campaigns',
        onclick: 'link',
        link: '/campaigns/campaigns/{id}',
        data: {
            data: [],
            metadata: []
        },
        userfilter:[
            {
                source: 'ATRNAME',
                label: 'Name',
                type: 'text',
                default: ''
            },
            {
                source: 'status',
                label: 'Status',
                type: 'select',
                default: '',
                options: {
                    '': 'All',
                    'true': 'Active',
                    'false': 'Inactive'
                }
            },
            {
                source: 'flow_id',
                label: 'Flow',
                type: 'select',
                default: '',
                options: {}
            }
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'ATRNAME',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Description',
                source: 'description',
                type: 'text',
                editable: true,
                default: '',
            },
            {
                label: 'Status',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true,
                classnames: {
                    true: 'label label-info',
                    false: 'label label-danger'
                }
            },
            {
                label: 'Flow',
                source: 'flow.name',
                type: 'text',
                editable: false,
                default: '',
            },
            {
                label: 'Users',
                source: 'users_clean',
                type: 'array',
                editable: false,
                default: [],
                render: (users) => {
                    if (!users || users.length === 0) return 'No users assigned';
                    return users.map(user => user.name).join(', ');
                }
            },
            {
                label: 'Created',
                source: 'ATRCREATETM',
                type: 'datetime',
                editable: false,
                default: '',
            },
            {
                label: 'Delete',
                type: 'delete'
            }
        ]
    }
    const tabs = [
        {
            link: '/campaigns/campaigns',
            name: 'Campaigns'
        },
        {
            link: '/campaigns/scheduler',
            name: 'Scheduler'
        }
    ]
    return (
            <Panel title = "Campaigns">
                <>
                <Tabs tabs={tabs} />
                <DataResource
                    data = {data}
                    {...props} 
                    addButtonText="Create New Campaign"
                    addButtonType="link"
                    addButtonLink="/campaigns/campaigns/create"
                />
                </>
            </Panel>
        )
    }


export default Campaigns;
